// extracted by mini-css-extract-plugin
export default {"topPanel":"TopPanel_topPanel__mHIrm","container":"TopPanel_container__qj9zu","currentPage":"TopPanel_currentPage__ENf4A","button":"TopPanel_button__fWJ8O"};